import { aY as NATIVE_TOKEN_ADDRESS } from './index-b21b6dcf.browser.esm.js';
import { i as isNativeToken } from './fetchCurrencyValue-395431ac.browser.esm.js';

function cleanCurrencyAddress(currencyAddress) {
  if (isNativeToken(currencyAddress)) {
    return NATIVE_TOKEN_ADDRESS;
  }
  return currencyAddress;
}

export { cleanCurrencyAddress as c };
